import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots } from "vue"

import type { Company, SharedData } from '@/types';
    import PageCard from '@/components/PageCard.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/procedures';
    import { useQuery } from '@tanstack/vue-query';
    import axios from 'axios';
    import QueryKey from '@/enums/QueryKey';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import CreateProcedure from './CreateProcedure.vue';
    import { computed, watch } from 'vue';
    import { useDashboardStore } from '@/stores/dashboard';
    import { usePage } from '@inertiajs/vue3';
    import { useI18n } from 'vue-i18n';
    import HoverInfo from '@/components/HoverInfo.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDashboardProcedures',
  props: {
    company: {}
  },
  setup(__props: any) {

    const props = __props;

    const page = usePage<SharedData>();
    const { t } = useI18n();
    const { hasPermission } = usePermissions();
    const dashboardStore = useDashboardStore();

    const companyId = computed(() => props.company.id);
    const isClient = computed(() => page.props.auth.user.is_client);

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.DASHBOARD_PROCEDURES, companyId],
        queryFn: getProcedures,
    });

    async function getProcedures() {
        const { data } = await axios.get(route('v2.dashboard.procedures.get'));
        return data.data;
    }

    watch(data, (newVal) => {
        if (newVal) {
            dashboardStore.setProcedureCount(newVal.length);
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageCard, { class: "mt-0 overflow-hidden md:mt-1.5 md:ml-0" }, {
    default: _withCtx(() => [
      _createVNode(DataTable, {
        "table-key": _unref(QueryKey).DASHBOARD_PROCEDURES,
        columns: _unref(columns),
        data: _unref(data),
        loading: _unref(isPending),
        "default-column-visibility": {
                task_responsible_ids: false,
            },
        "default-sorting": [
                {
                    id: 'procedure_deadline_text',
                    desc: false,
                },
            ],
        "default-pagination": {
                pageIndex: 0,
                pageSize: 10,
            },
        "enable-search": false,
        "enable-filters": false
      }, _createSlots({
        title: _withCtx(() => [
          _createVNode(_unref(CardTitle), { class: "flex items-center gap-2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('dashboards.procedures_header')) + " ", 1),
              (isClient.value)
                ? (_openBlock(), _createBlock(HoverInfo, {
                    key: 0,
                    content: _unref(t)('dashboards.procedures_help')
                  }, null, 8, ["content"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        (_unref(hasPermission)(_unref(Permission).DASHBOARD_ADMIN_CREATE))
          ? {
              name: "actions",
              fn: _withCtx(() => [
                _createVNode(CreateProcedure, { company: _ctx.company }, null, 8, ["company"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["table-key", "columns", "data", "loading"])
    ]),
    _: 1
  }))
}
}

})